module.exports = __webpack_public_path__ + "static/media/20201219_112426_212_IMG_3350.01f6ca5d.jpg";